import { Component, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { PassaObjetoService } from '../../services/passa-objeto.service';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthService } from '../../services/user/auth.service';
import { DadosService } from '../../services/dados/dados.service';

@Component({
  selector: 'app-saude-lista',
  templateUrl: './saude-lista.page.html',
  styleUrls: ['./saude-lista.page.scss'],
})
export class SaudeListaPage implements OnInit {

  saudeItems: Observable<any[]>;
  formsArray: any;
  user:any;
  logado = false
  constructor(
    public navCtrl: NavController,
    public http: HttpClient,
    private router: Router,
    private authService: AuthService,
    private dadosService: DadosService,
    private passaObjetoService: PassaObjetoService,
  ) { }

  ngOnInit() {
    this.getUser()
    
  }


  novoSaude(){
    // console.log("novoSaude")
    this.router.navigate(['saude-lista'])
  }
  getUser() {

    this.authService.usuario.subscribe(usr => {
      if (usr !== undefined && usr.toString() !== "UNAUTHORIZED") {
        this.logado = true
        this.user = usr
        this.pegaFormulariosUsuario(usr.cdmatricula)
      }
    })

    
  }

  pegaFormulariosUsuario(cdmatricula) {
    this.dadosService.listaFormUsuario(cdmatricula).subscribe(forms => {
      // console.log("data", forms)
      this.formsArray = forms
    },
    error => {
      console.log("error", error)
    },
    () => {
      //this gets called on completion, callback code comes here
      console.log()
    });
  }

  verDetalhes(saude) {
    this.passaObjetoService.navParams = {form: saude}
    this.navCtrl.navigateForward("saude-detalhes");
  }

}
